import { UserOverview, UserRoleEnum } from './user';

export enum InvitationStatusEnum {
    PENDING = 'PENDING',
    EXPIRED = 'EXPIRED',
}

export type InvitationRoleEnum = Exclude<UserRoleEnum, UserRoleEnum.ADMIN>;
export type Invitation = {
    id: string;
    firm: { id: string; shortId: string; name: string };
    email: string;
    role: InvitationRoleEnum;
    status: InvitationStatusEnum;
    createdAt: Date;
    createdBy: UserOverview;
    expires: Date;
};
